export const HOME = {
  emergentLink: "emergent-link",
};

export const AUTH = {
  loginForm: "login-form",
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  loginButton: "login-submit-button",
  logoutButton: "logout-button",
};

export const ADMIN = {
  sidebarDashboard: "sidebar-dashboard",
  sidebarCustomers: "sidebar-customers",
  sidebarOrders: "sidebar-orders",
  sidebarProducts: "sidebar-products",
  sidebarPanelProducts: "sidebar-panel-products",
  sidebarImportProducts: "sidebar-import-products",
  sidebarExportProducts: "sidebar-export-products",
  addProductButton: "add-product-button",
  importExcelButton: "import-excel-button",
  exportExcelButton: "export-excel-button",
  downloadTemplateButton: "download-template-button",
  productTable: "product-table",
  productRow: "product-row",
  deleteProductButton: "delete-product-button",
  editProductButton: "edit-product-button",
};

export const PRODUCT_FORM = {
  tabBasic: "tab-basic-trigger",
  tabMedia: "tab-media-trigger",
  tabContent: "tab-content-trigger",
  tabVariants: "tab-variants-trigger",
  tabMOQ: "tab-moq-trigger",
  tabSuggestiveSP: "tab-suggestive-sp-trigger",
  tabRelated: "tab-related-trigger",
  tabSpecsQA: "tab-specs-qa-trigger",
  saveProductButton: "save-product-button",
  saveDraftButton: "save-draft-button",
  previewButton: "preview-button",
  itemNameInput: "product-item-name-input",
  productTypeInput: "product-type-input",
  skuInput: "product-sku-input",
  statusSelect: "product-status-select",
  brandNameInput: "product-brand-name-input",
  mrpInput: "product-mrp-input",
  dealPriceInput: "product-deal-price-input",
};

export const PRODUCT_PAGE = {
  addToCartButton: "frontend-add-to-cart-btn",
  buyNowButton: "frontend-buy-now-btn",
  wishlistButton: "frontend-wishlist-btn",
  colorSelect: "variant-color-select",
  sizeSelect: "variant-size-select",
  quantityInput: "quantity-input",
  bulkPricingTable: "moq-pricing-table",
  productTitle: "product-title",
  productPrice: "product-price",
  ratingStars: "rating-stars",
};
